const getFilteredChannels = (channels, activeCategory) => {
  return channels.filter((channel) => channel.category === activeCategory)
}

export { getFilteredChannels }
